import {EopModalDialog} from "./modalDialog";
import {BootStrapDialogOpener} from "./bootStrapDialogOpener";
import {resolve} from "../../../container";
import {PageFeatures} from "../pageFeatures";
import {Dictionary} from "../dictionary";

export class DialogOpener extends BootStrapDialogOpener {

    public constructor(
        dialogContent: HTMLElement,
        anchorElement: HTMLElement,
        disableCloseOnOutsideClick: boolean = false,
        pageFeatures: PageFeatures = resolve(PageFeatures)
    ) {
        const dialogElement = pageFeatures.insert(new EopModalDialog(dialogContent, Dictionary.of(anchorElement), disableCloseOnOutsideClick));
        super(dialogElement);
    }
}
